import { render, staticRenderFns } from "./TrancheReservationDetails.vue?vue&type=template&id=b8fd2714&"
import script from "./TrancheReservationDetails.vue?vue&type=script&lang=js&"
export * from "./TrancheReservationDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports